export const selectPendingWrites = state => state.firebase.pendingWrites;
